/**
 * Helper que renderiza el header de ayuda al inicio de cada pestaña:
 *  - Banner informativo dismissible (Capa 5)
 *  - Botón "Tips de Bookvia" contextual (Capa 3)
 *
 * Si el business tiene un `superGroup` (categoria macro: eventos, fitness,
 * mascotas, consultoria, aprendizaje, salud…), buscamos primero la variante
 * category-specific de banner/tips (ej. `services_eventos`) y solo caemos
 * al genérico si no existe.
 *
 * Solo se muestra si el idioma es español y el usuario NO es manager
 * (los managers ven una versión reducida del dashboard).
 */
import InfoBanner from './InfoBanner';
import BookviaTipsButton from './BookviaTipsButton';
import { tabBanners, tabBannersByCategory, bookviaTips, bookviaTipsByCategory } from '@/lib/dashboardHelp';

export default function TabHelpHeader({ tabKey, language, isManager, superGroup }) {
  if (language !== 'es' || isManager) return null;
  const categoryKey = superGroup ? `${tabKey}_${superGroup}` : null;
  const bannerText = (categoryKey && tabBannersByCategory[categoryKey]) || tabBanners[tabKey];
  // Merge per-category tips into the base tips map so BookviaTipsButton
  // (which reads by tabKey) shows the right variant without needing to
  // know about the category itself.
  const categoryTip = categoryKey ? bookviaTipsByCategory[categoryKey] : null;
  const mergedTips = categoryTip
    ? { ...bookviaTips, [tabKey]: categoryTip }
    : bookviaTips;
  return (
    <>
      {bannerText ? <InfoBanner storageKey={`tab-${tabKey}${superGroup ? `-${superGroup}` : ''}`} text={bannerText} /> : null}
      <div className="mb-4 flex justify-end">
        <BookviaTipsButton tabKey={tabKey} tipsData={mergedTips} />
      </div>
    </>
  );
}
